export const baseApaleoUrl = 'https://app.apaleo.com';
export const baseLumigoUrl = 'https://platform.lumigo.io/project';
export const devLumigoProject = '/c_fb3ea51b885b4';
export const prodLumigoProject = '/c_e0be1b22705a4';
export const invocationLumigoUrl = '/invocations/v2';
